import { useEffect, useRef } from 'react';

type Props = React.JSX.IntrinsicElements['video'];

const isPlaying = (video: HTMLVideoElement) =>
  !!(
    video.currentTime > 0 &&
    !video.paused &&
    !video.ended &&
    video.readyState > 2
  );
export const VideoAutoplay = ({ onError, ...props }: Props) => {
  const ref = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    const video = ref.current;

    if (video && !isPlaying(video)) {
      video.play().catch(() => {
        // Autoplay not allowed!
        // Mute video and try to play again
        video.muted = true;
        video.play().catch(e => {
          // 2nd trigger not working, call onError if provided
          onError?.(e);
        });
      });
    }
  }, [onError]);
  // oxlint-disable-next-line jsx-a11y/media-has-caption
  return <video playsInline {...props} ref={ref} />;
};
